// extracted by mini-css-extract-plugin
export default {"tabConsent":"TabConsent_tabConsent__By7hh"};